import './styles/fonts.css';
import './styles/tokens.css';
import './styles/tokens-extra.css';
import './styles/global.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { applyStoredConsent } from './features/cookies/consent';

applyStoredConsent();

const root = document.getElementById('root');
if (!root) throw new Error('Falta el elemento #root en index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/**
 * PWA: el service worker solo se registra en producción (ni en `pnpm dev` ni en las pruebas), y su
 * código va aparte y se descarga cuando la página ya cargó: la primera pantalla no lo espera.
 */
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const start = () => void import('./pwa/register').then((module) => module.registerServiceWorker());
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(start, { timeout: 5000 });
    else window.setTimeout(start, 2000);
  });
}
